import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import {
  loginWithEmail,
  loginWithGoogle as loginWithGoogleService,
  registerWithEmail,
  logout as logoutService,
  getAuthErrorMessage,
} from '../services/authService';

const AuthContext = createContext(null);

/** Re-export per compatibilità con chi importa da AuthContext. */
export { getAuthErrorMessage };

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const login = async (email, password) => {
    const signedInUser = await loginWithEmail(email, password);
    return signedInUser;
  };

  const register = async (email, password, displayName = null) => {
    await registerWithEmail(email, password, displayName);
  };

  const loginWithGoogle = async () => {
    const googleUser = await loginWithGoogleService();
    return googleUser;
  };

  const logout = async () => {
    await logoutService();
  };

  const value = {
    user,
    loading,
    login,
    register,
    loginWithGoogle,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
